import React, { forwardRef } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@navikt/aksel-icons";
import { useFilteredOptionsContext } from "../FilteredOptions/filteredOptionsContext.js";
import { useInputContext } from "./Input.context.js";
export const ToggleListButton = forwardRef(({ toggleListButtonLabel }, ref) => {
    const { isListOpen, toggleIsListOpen } = useFilteredOptionsContext();
    const { focusInput } = useInputContext();
    return (React.createElement("button", { type: "button", onPointerUp: () => {
            toggleIsListOpen();
            focusInput();
        }, onKeyDown: ({ key }) => key === "Enter" && toggleIsListOpen(), className: "navds-combobox__button-toggle-list", "aria-expanded": isListOpen, tabIndex: -1, ref: ref },
        React.createElement("span", { className: "navds-sr-only" }, toggleListButtonLabel !== null && toggleListButtonLabel !== void 0 ? toggleListButtonLabel : "Alternativer"),
        isListOpen ? (React.createElement(ChevronUpIcon, { "aria-hidden": true })) : (React.createElement(ChevronDownIcon, { "aria-hidden": true }))));
});
export default ToggleListButton;
//# sourceMappingURL=ToggleListButton.js.map